export const tableEntity = [
  { id: "entity_name", label: "Nome" },
  { id: "entity_type", label: "Tipo", type: "type-entity" },
  { id: "status", label: "Status", type: "status"},
  { id: "maturity_level", label: "Nível de Maturidade", type: "maturity-level" },
  { id: "actions", type: "actions", label: "" },
];
